module.exports = __webpack_public_path__ + "static/media/hea_sit_spe_met.023b0ed4.png";